export const catalog_matrix = [
  {form_key:'billing_account_type_id', catalog_key:'billing_account_types'},
  {form_key:'billing_account_status_id', catalog_key:'billing_account_statuses'},
  {form_key:'responsible_id', catalog_key:'none', propname:'users'},
]